import SimpleDialog from 'app/componentV4/Dialog/SimpleDialog'
import SimpleInput from 'app/componentV4/Input/SimpleInput'
import { Field, Form, Formik } from 'formik'
import React from 'react'
import { useIntl, FormattedMessage } from 'react-intl'
import OutlinedButtons from 'app/componentV4/Button/OutlinedButtons'
import { CLOSE, SECONDARY } from 'app/constants/button'
import ContainedButton from 'app/componentV4/Button/ContainedButton'
import { usePlace } from 'commons/usePlace'
import { useGroupDialog } from '../contexts/GroupDialogContext'
import { GROUP_TITLE_TEXT_MAX } from 'app/constants/group'
import { DIALOG_KEYS } from '../constants'

const EditNameGroup = () => {
  const { formatMessage } = useIntl()
  const place = usePlace()
  const { dialogState, closeDialog, setLoading } = useGroupDialog()
  const { open, action, isLoading } = dialogState[DIALOG_KEYS.GROUP_EDIT_NAME]

  const handleSubmit = async (values, { setFieldError }) => {
    setLoading(DIALOG_KEYS.GROUP_EDIT_NAME, true)
    const data = {
      name: values.name?.trim(),
      placeId: place.id,
      groupId: action?.group?.id,
    }

    action?.onSubmit?.({ data, setFieldError })
  }

  return (
    <SimpleDialog
      id="dialog-add-group"
      open={open}
      title={
        <div
          style={{ maxWidth: '500px', width: '500px' }}
          className="text-blue-950 py-5 px-10 text-16 font-medium"
        >
          <FormattedMessage id="groupPage.editGroup.name" />
        </div>
      }
      isLoading={isLoading}
      onClose={() => closeDialog(DIALOG_KEYS.GROUP_EDIT_NAME)}
    >
      <div className="py-5 px-10">
        <Formik
          initialValues={{
            name: action?.group.name,
          }}
          validate={(values) => {
            const errors = {}
            if (!values.name) {
              errors.name = formatMessage({
                id: 'composeDialog.field.required',
              })
            }

            if (values.name?.length > GROUP_TITLE_TEXT_MAX) {
              errors.name = formatMessage(
                {
                  id: 'maximum.characters.allowed',
                },
                { limit: GROUP_TITLE_TEXT_MAX },
              )
            }

            return errors
          }}
          onSubmit={handleSubmit}
        >
          {({
            dirty,
            isValid,
            isSubmitting,
            touched,
            errors,
            setFieldTouched,
          }) => (
            <Form>
              <div className="mb-5 w-full">
                <div className="w-fit flex text-14 font-medium text-blue-950 mb-1 capitalize">
                  <FormattedMessage id="group.details.dialogs.groupName" />
                  <label className="px-2 text-red-500">*</label>
                </div>

                <Field name="name">
                  {({ field }) => (
                    <SimpleInput
                      {...field}
                      id="name"
                      disabled={isLoading}
                      type="text"
                      className="h-48 w-full mb-1 sm:mb-0 bg-white rounded-8 text-blue-950"
                      placeholder={formatMessage({
                        id: 'group.table.th.groupName',
                      })}
                      onBlur={(e) => {
                        field.onBlur(e)
                        setFieldTouched('name', true)
                      }}
                      error={Boolean(errors.name)}
                      helperText={errors.name}
                    />
                  )}
                </Field>
              </div>

              <div className="flex justify-center space-x-5 m-5">
                <OutlinedButtons
                  type="button"
                  color={CLOSE}
                  disabled={isSubmitting || isLoading}
                  onClick={() => closeDialog(DIALOG_KEYS.GROUP_EDIT_NAME)}
                >
                  <FormattedMessage id="action.cancel" />
                </OutlinedButtons>
                <ContainedButton
                  color={SECONDARY}
                  type="submit"
                  isLoading={isLoading}
                  disabled={!dirty || !isValid || isSubmitting || isLoading}
                >
                  <FormattedMessage id="action.update" />
                </ContainedButton>
              </div>
            </Form>
          )}
        </Formik>
      </div>
    </SimpleDialog>
  )
}

export default EditNameGroup
